import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ValidateResultIcon from "../../common/ValidateResultIcon/ValidateResultIcon";

interface PasswordValidatorProps {
    password: string
}

export default function PasswordValidator(props: PasswordValidatorProps): JSX.Element {

    const { t } = useTranslation('profile');

    const { password } = props;

    useEffect(() => {
        setPasswordIsLong(password.length >= 11 && password.indexOf(' ') < 0);
        setPasswordHasUppercase((/[A-Z]+/).test(password));
        setPasswordHasLowercase((/[a-z]+/).test(password));
        setPasswordHasNumber((/[0-9]+/).test(password));
        setPasswordHasSpecialCharacter((/[^a-zA-Z0-9]+/).test(password));
    }, [password]);

    const [passwordIsLong, setPasswordIsLong] = useState(false);
    const [passwordHasUppercase, setPasswordHasUppercase] = useState(false);
    const [passwordHasLowercase, setPasswordHasLowercase] = useState(false);
    const [passwordHasNumber, setPasswordHasNumber] = useState(false);
    const [passwordHasSpecialCharacter, setPasswordHasSpecialCharacter] = useState(false);

    return (
        <div className="password-validate" >
            <div><ValidateResultIcon isValid={passwordIsLong} /> {t("edit-account.password-long-guide") as string}</div>
            <div><ValidateResultIcon isValid={passwordHasUppercase} /> {t("edit-account.password-uppercase-guide") as string}</div>
            <div><ValidateResultIcon isValid={passwordHasLowercase} /> {t("edit-account.password-lowercase-guide") as string}</div>
            <div><ValidateResultIcon isValid={passwordHasNumber} /> {t("edit-account.password-number-guide") as string}</div>
            <div><ValidateResultIcon isValid={passwordHasSpecialCharacter} /> {t("edit-account.password-special-guide") as string}</div>
        </div>
    )
}